module.exports = __webpack_public_path__ + "static/media/Storm_Argumentative.4ec21652.gif";